import { IDocumentType, TClientDoc } from '@/types/docTypes';

export function validatingDocWithRole(documentTypes: (TClientDoc|IDocumentType)[], currentRole: number) {
  if (!currentRole || !documentTypes.length) return documentTypes;
  const pattern = new RegExp(`(^|,)${currentRole}(,|$)`);
  return documentTypes.filter((d) => {
    return !d.blockAccessToDocumentType ? true : !pattern.test(d.blockAccessToDocumentType);
  });
}
